import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TbHomeMove } from "react-icons/tb";
import nav from "../../../assets/images/icons/nav-icon.svg";
import avatar from "../../../assets/images/profile_placeholder.png";
import dataContext from "../../../context/dataContext";
import mainContext from "../../../context/mainContext";

import styles from "./style.module.css";

//group c- yoav & yehoshua
const pagesHeadersWithOutBTNs = ["Comprehension"]
export default function HomeButton() {
  const { nav: { setIsShowNav }, avatarData } = useContext(mainContext);
  const { userDetails, serverData } = useContext(dataContext);
  let navigate = useNavigate();
  let location = useLocation()
  console.log("🚀 ~ HomeButton ~ location:", location)
  const handleHome = () => navigate("/");
  // const hideProfillPicNavBtn = pagesHeadersWithOutBTNs.includes(pageName)
  return (
    <div className={styles["header"]} style={{ justifyContent: "space-around", minWidth: "9dvw" }}>
      {!location.pathname.includes("setClassId") && <div className={styles["left"]} onClick={handleHome}>

        <TbHomeMove size={"35px"} color="#7d56a5" />

      </div>}

    </div>
  );
}
